<template>
  <div class="keyboard">
    <div class="keyboard--buttons">
      <div class="buttons-row">
        <button class="buttons-row__button" :class="{ 'clicked': clickedElement === 1 }" @click="clickAction(1)">
          <p>1</p>
        </button>
        <button class="buttons-row__button" :class="{ 'clicked': clickedElement === 2 }" @click="clickAction(2)">
          <p>2</p>
        </button>
        <button class="buttons-row__button" :class="{ 'clicked': clickedElement === 3 }" @click="clickAction(3)">
          <p>3</p>
        </button>
      </div>
      <div class="buttons-row">
        <button class="buttons-row__button" :class="{ 'clicked': clickedElement === 4 }" @click="clickAction(4)">
          <p>4</p>
        </button>
        <button class="buttons-row__button" :class="{ 'clicked': clickedElement === 5 }" @click="clickAction(5)">
          <p>5</p>
        </button>
        <button class="buttons-row__button" :class="{ 'clicked': clickedElement === 6 }" @click="clickAction(6)">
          <p>6</p>
        </button>
      </div>
      <div class="buttons-row">
        <button class="buttons-row__button" :class="{ 'clicked': clickedElement === 7 }" @click="clickAction(7)">
          <p>7</p>
        </button>
        <button class="buttons-row__button" :class="{ 'clicked': clickedElement === 8 }" @click="clickAction(8)">
          <p>8</p>
        </button>
        <button class="buttons-row__button" :class="{ 'clicked': clickedElement === 9 }" @click="clickAction(9)">
          <p>9</p>
        </button>
      </div>
      <div class="buttons-row">
        <button class="buttons-row__button" :class="{ 'clicked': clickedElement === '-' }" @click="clickAction('-')">
          <p>-</p>
        </button>
        <button class="buttons-row__button zero" :class="{ 'clicked': clickedElement === 0 }" @click="clickAction(0)">
          <p>0</p>
        </button>
      </div>
    </div>
    <div class="keyboard--controls" >
      <button class="button__delete" :class="{ 'clicked': clickedElement === 'delete' }" @click="clickAction('delete')">
        <span class="icon icon-delete"></span>
      </button>
      <button class="button_submit" :class="{ 'clicked': clickedElement === 'submit' }" @click="clickAction('submit')">
        <span class="icon icon-submit"></span>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        clickedElement: null
      }
    },
    props: [
      'handleKeyboardClick',
      'handleKeyboardDelete',
      'answerQuestion'
    ],
    methods: {
        clickAction(element) {
            this.clickedElement = element;

            switch (element) {
            case 'delete':
                this.handleKeyboardDelete();
                break;
            case 'submit':
                this.answerQuestion();
                break;
            default:
                this.handleKeyboardClick(element);
            }

            setTimeout(() => {
              this.clickedElement = null
            }, 100);
        }
    }
  }
</script>

<style scoped lang="scss">
  @font-face {
    font-family: 'icomoon';
    src:  url('../assets/fonts/icomoon.eot');
    src:  url('../assets/fonts/icomoon.eot') format('embedded-opentype'),
    url('../assets/fonts/icomoon.ttf') format('truetype'),
    url('../assets/fonts/icomoon.woff') format('woff'),
    url('../assets/fonts/icomoon.svg') format('svg');
    font-weight: normal;
    font-style: normal;
  }

  [class^="icon-"], [class*=" icon-"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: 'icomoon' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    vertical-align: middle;
  }
  .icon-delete:before {
    content: '\e901';
  }
  .icon-submit:before {
    content: '\e900';
  }
  .keyboard {
    display: flex;
    width: 100%;
    align-items: center;
    margin-top: 30px;
    max-width: 400px;
    &--buttons {
      width: 70%;
      padding: 0 10px;
      .buttons-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &__button {
          height: 50px;
          width: 33%;
          min-width: 65px;
          margin: 2px;
          background-color: #7822cc;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 15px;
          box-shadow: 0px 2px 10px rgba(0, 0, 0, .4);
          cursor: pointer;
          appearance: none;
          text-decoration: none;
          transition: all .2s ease-in-out;
          border: none;
          &.clicked {
            background-color: #601ba3 !important;
          }
          p {
            font-weight: 700;
            font-size: 30px;
            margin: 0;
            color: white;
          }
          &:hover, &:focus {
            text-decoration: none;
            border: none;
            outline: none;
          }
          &.zero {
            width: 67%;
            margin-left: 5px;
          }
        }
      }
    }
    &--controls {
      width: 30%;
      padding-right: 10px;
      .button__delete {
        height: 50px;
        width: 100%;
        background-color: #7822cc;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 15px;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, .4);
        cursor: pointer;
        border: none;
        transition: all .2s ease-in-out;
        &.clicked {
          background-color: #601ba3 !important;
        }
        &:hover, &:focus {
          text-decoration: none;
          border: none;
          outline: none;
        }
        .icon {
          font-size: 35px;
          color: white;
        }
      }
      .button_submit {
        width: 100%;
        height: 158px;
        background-color: #11b748;
        border-radius: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 6px;
        box-shadow: 0px 2px 30px rgba(0, 0, 0, .3);
        cursor: pointer;
        border: none;
        transition: all .2s ease-in-out;
        &:hover, &:focus {
          text-decoration: none;
          border: none;
          outline: none;
        }
        &.clicked {
          background-color: #23a24d;
        }
        .icon {
          font-size: 45px;
          color: white;
        }
      }
    }
  }
</style>
